export default {
  FixedTabs: {
    newPolicy: '¿Es esta una nueva póliza?',
    isNeeedToContactBeforeVisit: '¿Es necesario contactarse antes de la visita?',
    companySize: 'Tamaño de la compañía',
    jobTitle: 'Título laboral',
    bestWayToContactBefore: 'Mejor forma de contactarse antes',
    name: 'Nombre:',
    address: 'Domicilio',
    emailAddress: 'Dirección de correo electrónico:',
    doNotCallAfter: 'No llamar después de:',
    sellingagent: 'Último agente que vendió:',
    lastDispositionDate: 'Fecha de la última disposition:',
    leadsDescription: 'Descripción de contactos:',
    appointmentDate: 'Fecha/Hora de la cita:',
    homeBusiness: 'Negocio en casa:',
    policyholderTenure: 'Tenencia del titular de póliza:',
    yearsInBusiness: 'Años trabajando en el negocio:',
    industry: 'Industria:',
    numberOfEmployees: 'Número de empleados:',
    currentDisposition: 'Disposition actual:',
    lastAssignedTo: 'Último agente asignado',
    agentNotesDirections: 'Notas/instrucciones del agente:',
    lastDisposition: 'Última disposition:',
    home: 'Domicilio',
    leadtype: 'Tipo de contacto:',
    determinate: 'determinate',
    assignedLeads: 'Contactos asignados',
    unAssignedLeads: 'Contactos sin asignar',
    closedLeads: 'Contactos cerrados ',
    inspections: 'Inspecciones',
    myInspections: 'My Inspecciones',
    teamInspections: 'Inspecciones del equipo',
    references: 'References',
    reports: 'Reports',
    drafts: 'Drafts',
    pmaportal: 'PMA Portal',
    accounts: 'Accounts',
    settings: 'Settings',
    logoff: 'Logoff',
    underwritingmanuals: 'Underwriting Manuals',
    customername: 'Nombre del cliente',
    primarycontact: 'Contacto primario',
    residentialphone: 'Teléfono de residencia',
    insuredsdob: 'Fecha de nacimiento del asegurado',
    calltype: 'Visita de tipo:',
    residentialaddress: 'Domicilio de residencia',
    alternatephone: 'Teléfono alternativo',
    age: 'Edad',
    writingagent: 'Agente suscriptor',
    writingagentsmanager: 'Gerente del agente suscriptor',
    languagepreference: 'Idioma:',
    languagepreferenceIns: 'Idioma',
    writingagentcode: 'Código del agente suscriptor',
    appdate: 'Fecha de solicitud',
    initialpaymenttype: 'Tipo de pago inicial',
    recurringpaymenttype: 'Tipo de pago recurrente',
    policytype: 'Policy Type',
    grossannualhouseholdincome: 'Ingreso anual bruto familiar',
    apv: 'APV (Valor de prima anualizado)',
    monthlypremiuim: 'Prima mensual',
    language: 'Idioma:',
    grossindividualannualincome: 'Ingreso anual bruto individual',
    premiummode: 'Modo de prima',
    contactinfo: 'Información del contacto',
    businessinfo: 'Información de negocios',
    premiumbillingdate: 'Fecha de cobro preferida',
    policydetails: 'Detalles de la póliza',
    valueAddProductsOwned: 'Productos de valor agregado del titular de póliza:',
    businessname: 'Nombre de negocio',
    businessphone: 'Teléfono de negocio',
    businessaddress: 'Domicilio de negocio',
    occupation: 'Ocupación',
    script: 'Guión',
    customerexperience: 'Experiencia del cliente',
    trainingopportunity: 'Oportunidad de capacitación',
    nocontact: 'Sin contacto',
    comments: 'Comentarios',
    duplicateinspection: 'Inspección duplicada',
    submit: 'Enviar',
    whatcustomerexperience: 'Cuál fue la experiencia del cliente',
    trainingopportunityassociated: 'Seleccione las oportunidades de capacitación que están asociadas con esta inspección',
    duplicateinspectiontext: 'Por favor seleccione GUARDAR para confirmar que esta es una Inspección duplicada, si no, seleccione CANCELAR',
    submitreviewtext: 'Favor de revisar la información de inspección antes de enviar o seleccione Cancelar para editar:',
    submitpaymenttext: 'Monto de la prima revisada mensualmente, fecha de facturación y forma de Pago con el Titular de la póliza',
    couldnotcontact: 'Seleccione el motivo por el que no pudo hacer contacto',
    campaignName: 'Nombre de campaña:',
    payment: 'Pago',
    recommendedBestProductToSell: 'Recomendación del mejor producto para vender:',
    recommendedNextBestProductToSell: 'Recomendación del siguiente mejor productor para vender:',
    campaignPurpose: 'Propósito de la campaña:',
    attemptedContacts: 'Intentos por establecer contacto',
    appointment: 'Cita',
    sale: 'Venta realizada',
    noSale: 'Venta no realizada',
    edit: 'Editar',
    save: 'Guardar',
    cancel: 'Cancelar',
    poor: '1 Mala',
    rich: '5 Excelente',
    selectallthatapply: 'Seleccione todas las que correspondan',
    affordability: 'Asequibilidad',
    productknowledge: 'Conocimiento del producto',
    needsbasedselling: 'Venta en base a necesidad',
    billingprocess: 'Proceso de facturación',
    paymentmode: 'Forma de pago',
    familybusiness: 'Negocio familiar/de amistades',
    leftmessage: 'Se dejó mensaje',
    policyCancelled: 'Póliza cancelada',
    badphonenumber: 'Numero de teléfono equivocado',
    inspnotrequired: 'Inspeccion no fue necesaria',
    timeofsale: 'Inspector presente en el momento de la venta',
    estROPMailDate: 'Fecha estimada para el envio de la devolución de prima:',
    estROPInHomeDate: 'Fecha estimada de recibir la devolución de prima en casa:',
    rOPPolicy: 'Póliza número de la devolución de prima:',
    rOPProductName: 'Nombre de producto de la devolución de prima:',
    rOPModePremium: 'Modo de prima de la devolución de prima:',
    rOPBillingMode: 'Modo de facturación de la devolución de prima:',
    rOPRange: 'Rango de la devolución de prima:',
    rOPBenefitRecycle: 'Beneficio reciclado de la devolución de prima:',
    otherPoliciesToOffer: 'Otras pólizas que ofrecer:',
    dispositionNoSale: 'Disposition - Venta no realizada',
    doesnotQualify: 'No calificó',
    dispositionSale: 'Disposition - venta realizada',
    editLead: 'Editar contacto',
    contactInfo: 'Datos de contacto',
    residentialInfo: 'Información residencial',
    policyDetails: 'Detalles de la póliza',
    businessInfo: 'Información de negocios',
    other: 'Otra información',
    campaignDescription: 'Descripción de la campaña',
    inforcePolicies: 'Pólizas vigentes:',
    policyNo: 'Número de póliza',
    formNo: 'Número de formulario',
    policy: 'Póliza',
    benefit: 'Beneficio',
    premium: 'Prima',
    mode: 'Modo',
    t: 'Forma de pago',
    issueDate: 'Fecha de emisión',
    insuredName: 'Nombre del asegurado',
    insuredNameIns: 'Nombre del asegurado',
    lapsedPolicies: 'Pólizas vencidas:',
    lapseDate: 'Fecha de vencimiento',
    none: 'Ninguno',
    noLeadsAssigned: 'No hay contactos asignados',
    showing: 'Mostrando',
    of: 'de',
    clearFilter: 'Borrar filtros',
    notes: 'Notas:',
    searchAddress: 'Búsqueda por domicilio',
    searchName: 'Búsqueda por nombre',
    forMoreInfo: '*Para más información por favor consulte la página de detalles de la póliza',
    search: 'Buscar',
    searchNameManage: 'Búsqueda',
    searchAddressManage: 'Búsqueda',
    searchPhone: 'Búsqueda',
    days: 'días',
    day: 'día',
    combinedProducts: 'Nota: Pregunte acerca de otros productos de Combined para asegurar asequibilidad.',
    selectionRequired: 'Selección requerida',
    searchInsuredName: 'Búsqueda por nombre',
    searchWritingAgent: 'Búsqueda por agente',
    product: 'Producto',
    reassignedLeads: 'Estos contactos están siendo reasignados',
    select: 'Selección requerida',
    ok: 'Aceptar',
    records: 'registros',
    record: 'registro',
    insuredsName: 'Nombre del asegurado',
    insuredsNameIns: 'Nombre del cliente',
    selected: 'seleccionado',
    checking: 'Cuenta de cheque',
    creditDebitCard: 'Crédito o débito',
    inspectionScriptHeader: 'GUIÓN DE LLAMADAS DE INSPECCIONES',
    noInspectionsFound: 'No se encontraron inspecciones',
    dateofapp: 'Fecha de la solicitud',
    lineOneManager: 'Gerente activo de la línea 1',
    activeLastSellingAgentName: 'Último agente de ventas activo',
    isOrphaned: '¿Mostrar contactos sin agente activo?',
    deleteString: '¿Está seguro de que quiere borrar este contacto personal?',
    assignmentSource: 'Fuente de asignación',
    tier: 'Nivel',
    stateOpen: 'Estado:',
    cityOpen: 'Ciudad:',
    zipOpen: 'Código postal:',
    priorityLeadsTab: 'Contactos prioritarios',
    openLeadsTab: 'Contactos disponibles',
    closedViewTabCheck: 'No hay contactos cerrados a la vista',
    openLeadsSearchString: 'Favor de pulsar en buscar',
    priorityViewTabCheck: 'No hay contactos prioritarios disponibles',
    campaignType: 'Tipo de campaña'
  },
  Assign: {
    selectall: 'Select All',
    name: 'Nombre',
    state: 'Estado',
    county: 'Condado',
    city: 'Ciudad',
    zip: 'Código postal',
    leadtype: 'Tipo de contacto',
    campaign: 'Campaign',
    language: 'Idioma',
    streetaddress: 'Domicilio',
    lastassigned: 'Último agente asignado',
    sellingagent: 'Último agente que vendió',
    assignedto: 'Asignado a',
    disposition: 'Disposition',
    customername: 'Nombre del cliente',
    calltype: 'Visita de tipo',
    phoneNumber: 'Número de teléfono',
    writingagent: 'Agente suscriptor',
    division: 'División-Mercado',
    product: 'Producto',
    appdate: 'Fecha de solicitud',
    dateofapp: 'Fecha de la solicitud',
    expires: 'Fecha de vencimiento',
    assignto: 'Asignar a:',
    dmsc: 'DM/SC',
    agent: 'Agent',
    insuredName: 'Nombre del asegurado',
    selectperson: 'Seleccionar una persona',
    confirmassign: 'Confirmar la asignación',
    reconfirmassign: 'Confirmar reasignación',
    search: 'Buscar',
    person: 'persona',
    unassign: 'Desasignar',
    cancel: 'Cancelar',
    ok: 'Aceptar',
    reassign: 'Reasignar a:',
    reassignedLeads: 'Estos contactos están siendo reasignados',
    lineOneManager: 'Gerente activo de la línea 1',
    activeLastSellingAgentName: 'Último agente de ventas activo',
    isOrphanedHintText: 'Mostrar contactos sin agente',
    isOrphaned: '¿Mostrar contactos sin agente activo?',
    lastassignedDate: 'Última fecha asignada',
    lastassignedDateMD: 'Fecha en la que MD lo asignó',
    dateAssigned: 'Fecha de asignación',
    tier: 'Nivel',
    assignmentSource: 'Fuente de asignación',
    campaignType: 'Tipo de campaña'
  },
  AdminScreen: {
    assignques: '¿En cuál mercado le gustaría trabajar?',
    selectdiv: 'Seleccione la división y el mercado',
    selectDivision: 'Seleccione la división y el mercado:',
    leadsquesn: '¿Le gustaría asignar contactos a otro mercado?',
    yes: 'Sí',
    no: 'No',
    max2: '(Máximo 2):',
    continue: 'Continuar',
    searchText: 'división y mercado'
  },
  Manage: {
    selectall: 'Select All',
    name: 'Nombre',
    state: 'Estado',
    county: 'Condado',
    city: 'Ciudad',
    zip: 'Código postal',
    address: 'Domicilio',
    leadtype: 'Tipo de contacto',
    campaign: 'Campaign',
    language: 'Idioma',
    streetaddress: 'Domicilio',
    streetAddress: 'Domicilio',
    lastassigned: 'Último a quien fue asignado:',
    sellingagent: 'Último agente que vendió:',
    assignedto: 'Asignado a',
    disposition: 'Disposition',
    customername: 'Nombre del cliente',
    calltype: 'Visita de tipo',
    phoneNumber: 'Número de teléfono',
    phone: 'Teléfono',
    writingagent: 'Agente suscriptor',
    division: 'División-Mercado',
    product: 'Producto:',
    appdate: 'Fecha de solicitud',
    dateofapp: 'Fecha de la solicitud',
    assignto: 'Asignar a:',
    dmsc: 'DM/SC',
    agent: 'Agent',
    selectperson: 'Seleccionar una persona',
    confirmassign: 'Confirmar la asignación',
    reconfirmassign: 'Confirmar reasignación',
    newPersonalLead: 'Nuevo contacto personal',
    expires: 'Fecha de vencimiento',
    searchAddress: 'Búsqueda por dirección',
    searchName: 'Búsqueda por nombre',
    search: 'Buscar',
    reminderXminutesbefore: 'Recordatorio \'X\' minutos antes',
    tier: 'Nivel',
    stateOpen: 'Estado:',
    cityOpen: 'Ciudad:',
    zipOpen: 'Código postal:',
    searchCriteriaMsg: 'Selección requerida',
    ok: 'Aceptar',
    openLeadsSearch: '¿En dónde le gustaría trabajar?',
    cancel: 'Cancelar',
    selectionRequiredHint: 'Selección requerida',
    hippa: 'Cliente HIPAA:',
    campaignType: 'Tipo de campaña'
  },
  Popup: {
    title: 'Nombre',
    location: 'Ubicación de la cita',
    startDate: 'Fecha de la cita',
    startTime: 'Hora de la cita',
    endDate: 'Fecha en que termina la cita',
    endTime: 'Hora en que termina la cita',
    hour: 'Hora',
    minute: 'Minuto',
    meridian: 'AM/PM',
    reminderXminutesbefore: 'Recordatorio \'X\' minutos antes',
    cancel: 'Cancelar',
    ok: 'Aceptar',
    policyNum: 'Número de póliza',
    searchPolicy: 'Búsqueda por póliza',
    save: 'Guardar',
    firstName: 'Primer nombre',
    lastName: 'Apellido',
    phoneNumber: 'Número de teléfono',
    type: 'Tipo',
    residence: 'Residencia',
    business: 'Negocio',
    address: 'Domicilio',
    dOB: 'Fecha de nacimiento',
    update: 'Actualizar',
    editLead: 'Editar contacto',
    home: 'Domicilio',
    additionalNoCell: 'Número adicional (cell)',
    language: 'Idioma:',
    calltype: 'Visita de tipo:',
    primaryContact: 'Contacto principal:',
    emailAddress: 'Dirección de correo electrónico:',
    businessname: 'Nombre de negocio:',
    zipCityState: 'Código postal / Ciudad / Estado',
    state: 'Estado',
    city: 'Ciudad',
    zip: 'Código postal',
    comments: 'Comentarios',
    none: 'Ninguna',
    noLeadsAssigned: 'No hay contactos asignados',
    searchAddress: 'Búsqueda por dirección',
    searchName: 'Búsqueda por nombre',
    search: 'Buscar',
    errorMessage: 'Favor de llenar todos los campos obligatorios',
    alert: 'Advertencia',
    pleaseSelectPolicy: 'Favor de seleccionar una póliza del menú de despliegue',
    stateOpen: 'Estado:',
    cityOpen: 'Ciudad:',
    zipOpen: 'Código postal:'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/es.js